module.exports = __webpack_public_path__ + "img/ucslogoPDF.639ed284.png";